import { useGetUserInfo } from "hooks/useGetUserInfo";
import { RecruiterJobs } from "../components/RecruiterJobs";
import { TalentJobs } from "../components/TalentJobs";

export const Jobs = () => {
  const { token, userInfo } = useGetUserInfo();

  return userInfo?.recruiter ? <RecruiterJobs /> : <TalentJobs />;
};

